import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ResourceService, NavigationService, AlertService, UserService } from 'sce-core';
import { LeftPanelService, DatePickerConfigService } from 'sce-ui-lib';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { DockDoorBookingDataEditorService } from '../services/dock-door-booking-data-editor.service';
import { DockDoorBookingDataService } from '../services/dock-door-booking-data.service';
import { DockDoorBookingActionService } from '../services/dock-door-booking-action.service';
import { DATE_FORMATS, META_DATA, TABLE_NAME } from '../../../../../constants';

@Component({
  selector: 'lfwms-dock-door-booking-primary-accordian',
  templateUrl: './dock-door-booking-primary-accordian.component.html',
  styleUrls: ['./dock-door-booking-primary-accordian.component.css']
})
export class DockDoorBookingPrimaryAccordionComponent extends AbstractFormWidgetComponent implements OnInit {

  public dataService: DockDoorBookingDataService;
  public dataEditor: DockDoorBookingDataEditorService;
  private tableId: any = this.actionService.tableIds;
  public META_DATA = META_DATA;

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected actionService:DockDoorBookingActionService,
    protected dateConfigService: DatePickerConfigService) {
    super(resourceService, navService, leftPanelService,
      alertService, userService, dateConfigService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    if (this.dataService.displayMode === 'C' && this.dataService.selectedCellData) {
      this.cellDataMap[META_DATA.FACILITY].cVal = this.dataService.selectedCellData.facility;
      this.cellDataMap[META_DATA.FROM_DOOR].cVal = this.dataService.selectedCellData.fromDoor;
      this.cellDataMap[META_DATA.BOOKING_DATE].cVal = new Date(this.dataService.selectedCellData.date);
      this.cellDataMap[META_DATA.BOOKING_DATE].cVal = moment(this.cellDataMap[META_DATA.BOOKING_DATE].cVal).format(DATE_FORMATS.DATE_ONLY) + ' ' + this.dataService.selectedCellData.bookingTimefr;
      this.cellDataMap[META_DATA.FROM_BOOKING_TIME].cVal = this.dataService.selectedCellData.bookingTimefr;
     
    } 
    if (this.dataService.displayMode === 'C' && this.dataService.selectedCellData && this.tableId === 'ddbooktd') {
      this.cellDataMap['toDoor'].cVal = this.dataService.selectedCellData.toDoor;
      this.dataEditor.populateCallTime();
    }
    if (this.dataService.displayMode === 'C' && this.dataService.selectedCellData && (this.tableId === 'ddbooktd' || this.tableId === 'ddbookintd')) {
      this.cellDataMap[META_DATA.FROM_BOOKING_TIME].cVal = this.dataService.selectedCellData.bookingTimefr;
      this.cellDataMap[META_DATA.BOOKING_TIME].cVal = moment(this.cellDataMap[META_DATA.BOOKING_DATE].cVal).format(DATE_FORMATS.DATE_ONLY) + ' ' + this.dataService.selectedCellData.bookingTimeto;
    } else {
      if (this.tableId !== TABLE_NAME.DOCK_DOOR_TABLE && this.cellDataMap[META_DATA.FROM_BOOKING_TIME].cVal) {
        let time = moment(this.cellDataMap[META_DATA.FROM_BOOKING_TIME].cVal);
        this.cellDataMap[META_DATA.FROM_BOOKING_TIME].cVal = time.format(DATE_FORMATS.TIME_ONLY);
      }
      if (this.tableId == TABLE_NAME.DOCK_DOOR_TABLE && this.cellDataMap[META_DATA.BOOKING_DATE].cVal && this.cellDataMap[META_DATA.FROM_BOOKING_TIME].cVal) {
        let time = moment(this.cellDataMap[META_DATA.FROM_BOOKING_TIME].cVal);
        let completeTime = time.format(DATE_FORMATS.FULL_TIMESTAMP);
        if (this.cellDataMap[META_DATA.FROM_BOOKING_TIME].cVal != this.cellDataMap[META_DATA.BOOKING_DATE].cVal)
          this.cellDataMap[META_DATA.BOOKING_DATE].cVal = this.cellDataMap[META_DATA.BOOKING_DATE].cVal + " " + completeTime;
      }
    }
    this.dataEditor.populateDoorValuesBasedOnFacilityInAccordion();
  }

  public realignWidget(): void {
    let cellsPerRow: number = 0;
    this.windowWidth = window.innerWidth - this.sidePanelWidth;

    switch (true) {
      case (this.windowWidth > 1250): {
        cellsPerRow = 5;
        break;
      }
      case (this.windowWidth <= 1250 && this.windowWidth > 1030): {
        cellsPerRow = 4;
        break;
      }
      case (this.windowWidth <= 1030 && this.windowWidth >= 800): {
        cellsPerRow = 3;
        break;
      }
      case (this.windowWidth <= 800 && this.windowWidth >= 560): {
        cellsPerRow = 2;
        break;
      }
      case (this.windowWidth < 560): {
        cellsPerRow = 1;
        break;
      }
      default: {
        cellsPerRow = 5;
        break;
      }
    }
    const newPropertyList = this.removeHiddenFields();
    this.propertyList = this.preparePropertyGrid(newPropertyList, cellsPerRow);
  }

  public removeHiddenFields() {
    const propertyListArray = this.widgetConfig.propertyList;
    const newPropertyListArray = [];
    for (let i = 0; i < propertyListArray.length; i++) {
      if (this.metadataMap[propertyListArray[i]]['displayType'] !== 'H') {
        newPropertyListArray.push(propertyListArray[i]);
      }
    }
    return newPropertyListArray;
  }

  // Method to define grid layout for each accordion.
  private preparePropertyGrid(propertyList: Array<any>, cellsPerRow) {
    let accordionRow;
    const accordionDefinition = [];
    for (let x = 0; x < propertyList.length; x++) {
      if (x % cellsPerRow === 0) {
        if (accordionRow && accordionRow.length === cellsPerRow) {
          accordionDefinition.push(accordionRow);
        }
        accordionRow = [];
      }
      accordionRow.push(propertyList[x]);
    }
    if (accordionRow && accordionRow.length !== 0) {
      for (let y = accordionRow.length; y < cellsPerRow; y++) {
        accordionRow.push('dummy');
      }
      accordionDefinition.push(accordionRow);
    }
    return accordionDefinition;
  }

  public getCellDisplayValue(property: any): any {
    if (property === META_DATA.DURATION) {
      //LFWM-4874-change in logic to get hours diff between 2 dates for duration field
      let fromBookingTime = this.cellDataMap[META_DATA.BOOKING_DATE].cVal;
      let bookingTime = this.cellDataMap[META_DATA.BOOKING_TIME].cVal;
      if (!fromBookingTime || !bookingTime) {
        return '-';
      }
      if (fromBookingTime && bookingTime) {
        const dateOneObj: any = new Date(bookingTime);
        const dateTwoObj: any = new Date(fromBookingTime);
        const milliseconds = Math.abs(dateTwoObj - dateOneObj);

        const seconds = (milliseconds / 1000) % 60;
        const minutes = ((milliseconds / (1000 * 60)) % 60);
        const hourss = ((milliseconds / (1000 * 60 * 60)));

        this.actionService.finalDuration = '1900-01-01' + ' ' + hourss + ':' + minutes + ':' + seconds + '.' + '000';
        return `${hourss.toString().split('.')[0]}hr${minutes}min`;
      }
    } else if (property === 'callTime') {
      const callTime = this.cellDataMap['callTime'].cVal;
      if(!callTime){
        return '00:00';
      }
      return moment(callTime).format('HH:mm');
    }
    return super.getCellDisplayValue(property);
  }
  
  public valueChanged(key: any, sourceEvent?: any): void {
    super.valueChanged(key, sourceEvent);
    if (key === META_DATA.FACILITY) {
      this.dataEditor.populateCallTime();
      this.dataEditor.populateDoorValuesBasedOnFacilityInAccordion();
    } else if ((key === META_DATA.BOOKING_DATE || key === META_DATA.FROM_BOOKING_TIME) && this.tableId === 'ddbooktd') {
      this.dataEditor.populateCallTime();
    }
    //LFWM-4874- adding date validation
    if (key == META_DATA.BOOKING_DATE || key == META_DATA.BOOKING_TIME) {
      this.actionService.validBookingDt = true;
      let fromBookingTime;
      let bookingTime;
      if (key == META_DATA.BOOKING_DATE) {
        fromBookingTime = new Date(sourceEvent);
      } else {
        fromBookingTime = new Date(this.cellDataMap[META_DATA.BOOKING_DATE].cVal);
      }
      if (key == META_DATA.BOOKING_TIME) {
        bookingTime = new Date(sourceEvent);
      } else {
        bookingTime = new Date(this.cellDataMap[META_DATA.BOOKING_TIME].cVal);
      }
      if (fromBookingTime && bookingTime && typeof (fromBookingTime) == "object" && typeof (bookingTime) == "object") {
        this.actionService.validBookingDt = true;
        if (bookingTime < fromBookingTime) {
          this.actionService.validBookingDt = false;
          this.alertService.error(this.resourceService.get('dd_datetime_range'));
          return;
        }
      }
    }
    super.valueChanged(key, sourceEvent);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/outbound/dock-door-booking/dock-door-booking-home/dock-door-booking-primary-accordian/dock-door-booking-primary-accordian.component.ts